import React, { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import "./BankDetailsSelectionModal.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Input } from "@mui/material";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { json } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BankDetailsSelectionModal = ({
  open,
  setOpen,
  selectedOrders,
  calculatedTotal,
  selectedRestaurant,
  selectedWithdrawTypes,
  withdrawSuccessfull,
  NeedToAdjustForPayload,
}) => {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [restaurantDatas, setRestaurantDatas] = useState([]);
  const [bankDetailsData, setBankDetailsData] = useState([]);
  const [restaurantAdded, setRestaurantAdded] = useState(null);
  const [bankDetails, setBankDetails] = useState(null);
  const [hasAmount, setHasAmount] = useState(false);
  const [hasServiceCharge, setHasServiceCharge] = useState(false);
  const [hasTips, setHasTips] = useState(false);
  const [widthdrawFeesOrder, setWidthdrawFeesOrder] = useState(null);

  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) { }
    }
    const restaurant = JSON.parse(localStorage.getItem("restaurant"));
    try {
      await axios
        .get(
          apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          decodedData.UserId +
          "/" +
          restaurant.id
        )
        .then((response) => {
          var list = [];
          response.data.map((dt, i) => {
            var obj = {
              id: dt.id,
              name: dt.name,
              address: dt.addressLine1,
              PhoneNumber: dt.phoneNumber,
              Email: dt.emailAddress,
              isActive: dt.isActive,
            };
            list.push(obj);
          });

          setRestaurantDatas(list);
        });
    } catch (error) {
      console.log("restaurant data fetching error");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const getBankDetails = async (restaurantId) => {
    const token = localStorage.getItem("gotasteadmintoken");
    try {
      await axios
        .get(apiAddress + "/api/RestaurantBankDetails/" + restaurantId)
        .then((response) => {
          var list = [];
          response.data.map((dt, i) => {
            var obj = {
              id: dt.id,
              restaurantId: dt.restaurantId,
              accountNumber: dt.accountNumber,
              name: dt.name,
              address: dt.addressLine1,
              PhoneNumber: dt.phoneNumber,
              Email: dt.emailAddress,
              isActive: dt.isActive,
            };
            list.push(obj);
          });
          setBankDetailsData(list);
        });
    } catch (error) {
      console.log("bank details data fetching error");
    }
  };

  useEffect(() => {
    if (selectedRestaurant !== null) {
      getBankDetails(selectedRestaurant?.id);
    }
  }, [selectedRestaurant]);

  const handleClose = () => {
    setOpen(false);
  };

  const saveWithDraw = async () => {
    if (selectedOrders.length === 0) {
      toast.error("Find and select orders to withdraw!");
      return;
    }

    try {
      const restaurantId = selectedRestaurant?.id;
      const bankId = bankDetails?.id;

      const url = `${apiAddress}/api/RestaurantBankDetails/SaveWithdraw?restaurantId=${restaurantId}&bankId=${bankId}`;
      const payload = {
        id: "12345",
        orderPaymentId: selectedOrders[0].orderPaymentId,
        selectedOrders: selectedOrders,
        needToAdjusts: NeedToAdjustForPayload,
        withdrawFeesOrder: widthdrawFeesOrder,
        Amount: hasAmount
          ? calculatedTotal?.totalRemainingAmount
          : hasTips
            ? calculatedTotal?.remainingTipsAmount
            : hasServiceCharge
              ? (
                calculatedTotal?.remainingServiceChargeAmount +
                calculatedTotal?.remainingServiceChargeVatAmount
              ).toFixed(2)
              : 0.0,
        totalWithdrawableAmount: hasTips
          ? calculatedTotal?.remainingTipsAmount
          : hasServiceCharge
            ? (
              calculatedTotal?.remainingServiceChargeAmount +
              calculatedTotal?.remainingServiceChargeVatAmount
            ).toFixed(2)
            : calculatedTotal?.totalRemainingAmount,
        totalAmount:
          hasServiceCharge || hasTips
            ? 0
            : calculatedTotal?.totalRemainingAmount,
        totalTips: hasServiceCharge ? 0 : calculatedTotal?.remainingTipsAmount,
        totalServiceCharge: hasTips
          ? 0
          : (
            calculatedTotal?.remainingServiceChargeAmount +
            calculatedTotal?.remainingServiceChargeVatAmount
          ).toFixed(2),
        receivedAmount: hasAmount
          ? calculatedTotal?.totalRemainingAmount
          : hasTips
            ? calculatedTotal?.remainingTipsAmount
            : hasServiceCharge
              ? (
                calculatedTotal?.remainingServiceChargeAmount +
                calculatedTotal?.remainingServiceChargeVatAmount
              ).toFixed(2)
              : 0.0,
        matchAmount: 0.0,
        matchOrderId: "null",
        withdrawTypes: hasAmount
          ? "WT001"
          : hasServiceCharge && hasTips
            ? "WT004"
            : hasTips
              ? "WT002"
              : "WT003",
      };

      // console.log("mkmk", payload);
      // return;

      await axios.post(url, payload).then((response) => {
        toast.info(response.data);
        setTimeout(() => {
          handleClose();
        }, 1000);
        withdrawSuccessfull();
      });
    } catch (error) {
      toast.error("Withdraw request failed");
    }
  };

  useEffect(() => {
    if (selectedWithdrawTypes === null) return;

    setHasAmount(selectedWithdrawTypes.id === "WT001");
    setHasServiceCharge(selectedWithdrawTypes.id === "WT003");
    setHasTips(selectedWithdrawTypes.id === "WT002");
  }, [selectedWithdrawTypes]);

  useEffect(() => {
    if (open) {
      // Reset user-selected fields in this modal
      setBankDetails(null);
      setWidthdrawFeesOrder(null);
    }
  }, [open]);

  const getWithdrawable = (option) => {
    return (
      (Number(option.totalRemainingAmount) || 0) +
      (Number(option.remainingTipsAmount) || 0) +
      (Number(option.remainingServiceChargeVatAmount) || 0) -
      (Number(option.totalTransactionFees) || 0)
    );
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <ToastContainer />
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Withdraw details
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <div className="d-flex align-items-center mb-4">
          <Box sx={{ width: 220 }}>
            {" "}
            {/* Set a fixed width for consistent alignment */}
            <Typography>Select Restaurant</Typography>
          </Box>

          <TextField
            id="outlined-basic"
            label="Restaurant"
            variant="outlined"
            aria-readonly
            value={selectedRestaurant?.name}
            style={{ width: "100%" }}
          />
        </div>
        <div className="d-flex align-items-center mt-4">
          <Box sx={{ width: 220 }}>
            {" "}
            {/* Same width as above */}
            <Typography>Select Bank Account</Typography>
          </Box>
          <Autocomplete
            disablePortal={false}
            sx={{ width: "100%" }}
            id="tags-outlined"
            clearText="clear"
            options={bankDetailsData}
            getOptionLabel={(option) => option.accountNumber}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            filterSelectedOptions
            onChange={(event, newInputValue) => {
              setBankDetails(newInputValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Bank Details"
                placeholder={"Banks"}
                required={true}
              />
            )}
            value={bankDetails}
            multiple={false}
          />
        </div>
        <div className="d-flex align-items-center gap-2 mt-4">
          <Box sx={{ width: 220 }}>
            <Typography>Withdrawal Fees</Typography>
          </Box>
          <Autocomplete
            disablePortal={false}
            sx={{ width: "100%" }}
            id="tags-outlined"
            clearText="clear"
            options={selectedOrders || []}
            getOptionDisabled={(option) => getWithdrawable(option) <= 1.5}

            getOptionLabel={(option) => {
              if (!option || !option.id) return "";
              const idSuffix = option.id.slice(-6);
              return `#${idSuffix} - Withdrawable: £${getWithdrawable(option).toFixed(2)}`;
            }}
            
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            filterSelectedOptions
            onChange={(event, newValue) => setWidthdrawFeesOrder(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Orders for fees"
                placeholder="Withdraw Fees from Orders"
                required
              />
            )}
            value={widthdrawFeesOrder || null}
            multiple={false}
          />

          {/* <Select
                        labelId="order-select-label"
                        label="Select Order"
                        id="order-select"
                        value=""
                        onChange={() => { }}
                    >
                        {selectedOrders.map(order => (
                            <MenuItem key={order.id} value={order.id}>
                                Order ID: #{order.id?.slice(-6)} - Withdrawable: £{(order.totalRemainingAmount + order.remainingTipsAmount + order.remainingServiceChargeVatAmount - order.totalTransactionFees).toFixed(2)}
                            </MenuItem>
                        ))}
                    </Select> */}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          // onClick={handleClose}
          onClick={saveWithDraw}
          disabled={bankDetails === null}
        >
          Withdraw
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default BankDetailsSelectionModal;
